import React, { useState, useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addFeaturestovendorr, postAddToVen, postFeatures } from '../../Redux/Actions/ActionPackages';
import { loadVendors } from '../../Redux/Actions/ActionVendors';
import Select from 'react-select';

function AddPackageToVendor({arr, open, setOpen }) {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const vendors = useSelector(state => state.vendorss.vendors)
    const [options, setoptions] = useState([])
    const [t, i18n] = useTranslation();
    const [vendor_id, setvendor_id] = useState(null);
    const [loadBtn, setloabBtn] = useState(false);
    useEffect(() => {
        dispatch(loadVendors())
    }, []);
    useEffect(() => {
        if (vendors.length >= 0) {
            const updatedOptions = vendors.map(category => ({
                value: category.id,
                label: category.name,
            }));
            setoptions(updatedOptions);
        }
    }, [vendors])
    const setcategory_idd = (selectedOption) => {
        if (selectedOption) {
            const value = selectedOption.value;
            setvendor_id(value);
        } else {
            setvendor_id(null);
        }
    }
    const FunSubmit = (e) => {
        e.preventDefault()
        console.log(arr.id);
        console.log(vendor_id);
        dispatch(postAddToVen(arr.id,vendor_id,setloabBtn))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center={true}
            classNames={{
                modal: "popAdd  widthnew",
            }}
            focusTrapped={false}
        >
            <div className='popAddForm' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""}>Add package to vendor</h3>
                <form>
                    <div className='input_row'>
                        <div className='widthnew'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('vendors')}</span>
                            </div>
                            <Select
                                defaultValue={vendor_id}
                                onChange={setcategory_idd}
                                options={options}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused ? 'grey' : 'rgb(214, 214, 214)',
                                        borderRadius: "10px",
                                        margin: "0px 10px",
                                        width: "100%"
                                    }),
                                }}
                            />
                        </div>
                    </div>
                </form>
                <div className='div_btn' ><button onClick={FunSubmit}  >
                    {
                        loadBtn ? "Loading ... " : <>Add to vendor</>
                    }
                </button></div>
            </div>
        </RModal>
    )
}

export default AddPackageToVendor;